import { useEffect, useState } from 'react';
import { chainManager } from '../ChainManager';

export const useEagerConnect = () => {
  const [tried, setTried] = useState(false);

  useEffect(() => {
    const tryEagerConnect = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve, 100));

        const currentChain = chainManager.getCurrentChain();
        const adapter = chainManager.getAdapter(currentChain);

        const isConnected = await adapter.isWalletConnected();
        if (isConnected) {
          setTried(true);
          return;
        }

        // Auto-connect is disabled by design; user must initiate connection
        setTried(true);
        return;
      } catch (error) {
        console.warn('Eager connect failed:', error);
      }
    };

    tryEagerConnect();
  }, []);

  return tried;
};
